export interface FormatPrice {
  (value: number): string;
}

export function createFormatPrice(lang: string, currency: string): FormatPrice {
  const nf = new Intl.NumberFormat(lang, {
    style: "currency",
    currency: currency,
    minimumSignificantDigits: 1,
  });
  return nf.format;
}
